/* eslint-disable no-use-before-define */
/* eslint-disable valid-jsdoc */
/**
 * Listen for consent events fired by consent.js
 * and push the data to GTM dataLayer + cache in localStorage
 */
function initConsentDataLayer() {
    // When user accepts all cookies
    $(document).on('consent:accepted', function (e, consentData) {
        pushConsent(consentData, 'consentAccepted');
    });

    // When user saves cookie preferences
    $(document).on('consent:preferencesSaved', function (e, consentData) {
        pushConsent(consentData, 'consentPreferencesSaved');
    });
}

/**
 * Push consent data to GTM dataLayer + cache
 * @param {Object} consentData
 * @param {string} eventName
 */
function pushConsent(consentData, eventName) {
    if (!consentData) return;

    // Push to GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        consentData: consentData
    });
}

module.exports = {
    initConsentDataLayer: initConsentDataLayer
};
